import TestimonialVideo from './TestimonialVideo';

export default TestimonialVideo;
